<div class="container-fluid">
  <div class="row">
    <div class="col-md-8">
      <div class="d-flex justify-content-center pt-3">
        <div class="Main-chessBoard">
          <div #boardContainer id="hijk"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4 puzzle-menu-section pt-3 px-2">
      <div class="m-2" style="color: var(--default-font-color);cursor: pointer;width: fit-content;"  (click)="puzzleMainroute()">
        <i class="fa-solid me-1 fa-arrow-left" style="color: var(--default-font-color);font-size: 15px;"></i>Back
      </div>

      <div class="text-center my-3">
        <h2 class="text-center Profile-title">Daily Puzzle</h2>
        <img src="../../../../assets/puzzles/Puzzle-img.png" style="width: 20%" alt="" />
      </div>

      <div class="d-flex justify-content-center mb-2">
        <div class="row justify-content-center p-0 m-0" id="puzzlesThemes">
          @for (theme of themes; track $index) {
          <div class="themes text-center col-lg-5 col-10">
            {{ theme }}
          </div>
          }
        </div>
        <hr />

      </div>
      <h5 class="Available-puzzle mt-1" id="puzzlesMovesDialogue">
        Finish this puzzle in
        <span style="font-size: larger">{{
          puzzleMoveLength?.length / 2
          }}</span>
        Moves.
      </h5>
      <div class="d-flex">
        <button (click)="hintPuzzle()" id="dailypuzzleHit" class="btn w-100 mt-2 mx-1 mb-2 hint-btn">
          <b>Hint</b>
        </button>
      </div>

      <div class="d-flex">
        <button (click)="puzzleMainroute()" id="solveMorePuzzlesBtn" class="btn w-100 mt-2 mx-1 mb-2 hint-btn">
          <b>Solve more puzzles</b>
        </button>
      </div>

      <!-- <div class="">
            <p class="text-white" id="finishdailyPuzzle">Congratulations Today's puzzle is Finished.</p>
        </div> -->
    </div>
  </div>
</div>